exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-e675ab22]{color:#000;width:-moz-fit-content;width:fit-content}@media (min-width:1024px){.flex_event_image[data-v-e675ab22]{max-width:40%}}", ""]);

// exports
